import React, { useState, useRef } from 'react';
import QRCode from 'qrcode';

const QRCodeGenerator = ({ asset, onClose }) => {
  const [qrDataURL, setQrDataURL] = useState('');
  const canvasRef = useRef();

  React.useEffect(() => {
    if (asset) {
      const qrData = JSON.stringify({
        id: asset.id,
        name: asset.name,
        saralId: asset.saralAssetId || `${asset.assetType?.name}-${asset.id}`,
        type: asset.assetType?.name
      });
      
      QRCode.toDataURL(qrData, { width: 200 })
        .then(url => setQrDataURL(url))
        .catch(err => console.error(err));
    }
  }, [asset]);

  const downloadQR = () => {
    const link = document.createElement('a');
    link.download = `${asset.name}-QR.png`;
    link.href = qrDataURL;
    link.click();
  };

  const printQR = () => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
        <head><title>Asset QR Code</title></head>
        <body style="text-align: center; padding: 20px;">
          <h3>${asset.name}</h3>
          <img src="${qrDataURL}" />
          <p>Asset ID: ${asset.saralAssetId || asset.id}</p>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <div className="text-center">
      {qrDataURL && (
        <>
          <img src={qrDataURL} alt="Asset QR Code" className="mb-3" />
          <div className="d-flex gap-2 justify-content-center">
            <button className="btn btn-primary btn-sm" onClick={downloadQR}>
              <i className="fas fa-download me-1"></i>Download
            </button>
            <button className="btn btn-secondary btn-sm" onClick={printQR}>
              <i className="fas fa-print me-1"></i>Print
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default QRCodeGenerator;